import { fetchTopTeachers } from "@/api/landing";

export default {
  namespaced: true,
  state: {
    topTeachers: [],
    loading: false,
  },
  mutations: {
    SET_TOP_TEACHERS(state, topTeachers) {
      state.topTeachers = topTeachers.map((item) => ({
        ...item,
        image: require("@/assets/teacher.png"),
      }));
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async loadTopTeachers({ commit, state }) {
      if (state.topTeachers.length > 0) return;
      commit("SET_LOADING", true);
      try {
        const response = await fetchTopTeachers();
        commit("SET_TOP_TEACHERS", response.data);
      } catch (error) {
        console.error("Ошибка загрузки категорий:", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    getTopTeachers: (state) => state.topTeachers,
    isTopTeachersLoading: (state) => state.loading,
  },
};
